import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useRef } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFVideo from '@/components/UI/EFVideo';

const { EFPic } = createEFPic('/media/deltapro/pc/');
gsap.registerPlugin(ScrollTrigger);
export default function Section5() {
    const { useEffect, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();
    const videoRef = useRef<HTMLVideoElement>();

    useEffect(() => {
        // const windowHeight = window.innerHeight
        /* -start- 白天-黑夜动画 */

        const playVideo = () => {
            if (locale == 'jp') {
                videoRef.current?.play();
            }
        };

        const TL = gsap.timeline({
            scrollTrigger: {
                trigger: '.section5',
                toggleActions: 'restart pause reverse pause',
                scrub: 0.5,
                start: 'top top',
                end: `+=150%`,
                onEnter() {
                    playVideo();
                },
                onEnterBack() {
                    playVideo();
                },
            },
        });
        TL.to('.section5 .img_light', {
            opacity: 1,
            duration: 1,
        });
        TL.to('.section5 .img_light .img_text', {
            opacity: 1,
            duration: 1,
        });
        /* -end- 白天-黑夜动画 */
        return () => {
            TL.kill();
        };
    }, []);

    return (
        <div className={`${css.section5} sec5-sticky-wrapper GtmModuleData-section`} data-section-id={css.section5} data-section-title={t('capactity_desc')}>
            <div className="sec5-sticky-container">
                <div className="img_container">
                    {locale === 'jp' ? (
                        <>
                            <EFVideo
                                ref={videoRef}
                                autoPlay={false}
                                loop={false}
                                sources={['/video/deltapro/lighting.webm', '/video/deltapro/lighting.mp4']}
                                className="lighting"
                            />
                            <div className="img img_light">
                                <div className="img_text font-family-semibolder">{t('capactity_desc')}</div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="img img_black">
                                <div className="imgBox">
                                    <EFPic name={['section_5_1.webp', 'section_5_1.jpg']} alt={t('capactity_desc')} aria-label={t('capactity_desc')} />
                                </div>
                            </div>
                            <div className="img img_light">
                                <div className="imgBox">
                                    <EFPic name={['section_5_2.webp', 'section_5_2.jpg']} alt={t('capactity_desc')} aria-label={t('capactity_desc')} />
                                </div>

                                <div className="img_text font-family-semibolder">{t('capactity_desc')}</div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
